import { render, staticRenderFns } from "./imcroframe.vue?vue&type=template&id=2b2d0a94&scoped=true"
import script from "./imcroframe.vue?vue&type=script&lang=js"
export * from "./imcroframe.vue?vue&type=script&lang=js"
import style0 from "./imcroframe.vue?vue&type=style&index=0&id=2b2d0a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d0a94",
  null
  
)

export default component.exports